import { render, staticRenderFns } from "./FaqTable.vue?vue&type=template&id=3885ec24&scoped=true"
import script from "./FaqTable.vue?vue&type=script&lang=js"
export * from "./FaqTable.vue?vue&type=script&lang=js"
import style0 from "./FaqTable.vue?vue&type=style&index=0&id=3885ec24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3885ec24",
  null
  
)

export default component.exports